import React, { useEffect, useState } from "react";
import "./Css/groovePQR_pdf.css";
import { Modal } from "react-bootstrap";
import { jsPDF } from "jspdf";
import { fetchImagePreview } from "../../utility/common/TransactionComponents/CommonImages";
import BarLoader from "react-spinners/BarLoader";

import Groove_pdf_page1PQR from "./Pages/Groove_pdf_page1PQR";
import Groove_pdf_page2PQR from "./Pages/Groove_pdf_page2PQR";
import Groove_pdf_page2 from "./Pages/Groove_pdf_page2";
import { getdetailsById } from "../../../Services/pqr-details-service";
import { getbyprojectno } from "../../../Services/pqr-header-service";
import PQRTubeToTubesheet_pdf_page1 from "./Pages/PQRTubeToTubesheet_pdf_page1";
import PQRTubeToTubesheet_pdf_page2 from "./Pages/PQRTubeToTubesheet_pdf_page2";
import PQRTubeToTubesheet_pdf_page3 from "./Pages/PQRTubeToTubesheet_pdf_page3";

import Jspdf_font from "../../../Assests/font/jsPdf_font";

const Pdf_DownloadPQR = (props, wld) => {

  const [showSuccessModel] = useState(false);
  const [showForm] = useState(false);
  const [showConfirmModel] = useState(false);
  const [loading, setLoading] = useState(true);

  const [PreviewUrl] = useState([]);
  const imageUrls = {
    previewUrl1: null,
    previewUrl2: null,
    previewUrl3: null,
    previewUrlgroove1: null,
    previewUrlgroove2: null,
    previewuser: "",
    previewapproved: ""
  }
  const [pdfData, setPdfData] = useState({ pdf: [], imageUrls: imageUrls });

  let folderwld = "wld_signatures";
  let folderpqr = "PQR_GrooveOverlay";
  let folderpqrtube = "PQR_Tubesheet";

  const fetchPdfWithImages = async (IddetailPK, IddetailSK) => {
    // Fetch PDF data
    let reqDetailParam = {
      id1: props.rowdata.wld_WPSType,
      id2: IddetailSK,
    };
    const result = await getdetailsById(reqDetailParam);

    let reqParam = {
      groovetype: props.rowdata.wld_WPSType,
      pkid: IddetailPK,
      skid: IddetailSK,
    };
    const pqrhead = await getbyprojectno(reqParam);
    
    // Filter processes based on showreport flag before creating PDF array
    const filteredProcesses = result.filter(process => process?.showreport === true);

    const processOrder = pqrhead[0]?.WPSH_PQR_Process;
    let sortedProcesses = filteredProcesses;
    if (processOrder) {
      const orderList = processOrder.split(",").filter(Boolean);
      sortedProcesses = orderList
        .map(process => filteredProcesses.find(item => item.PQR_Process === process))
        .filter(Boolean);
    }

    const pdfArray = [pqrhead[0], ...sortedProcesses];

    // Debug logs for PDF
    console.log('=== PDF DATA STRUCTURE ===');
    console.log('Original processes count:', result.length);
    console.log('Filtered processes count:', filteredProcesses.length);
    console.log('Filtered processes:', filteredProcesses.map(p => ({ 
      process: p.PQR_Process, 
      type: p.PQR_Type, 
      showreport: p.showreport 
    })));
    console.log('PDF Array:', pdfArray);
    console.log('PDF Array Length:', pdfArray.length);
    console.log('PDF[0] (Header):', pdfArray[0]);
    console.log('PDF[1] (Details):', pdfArray[1]);
    if (pdfArray[1]) {
      console.log('Visual Examination in PDF:', pdfArray[1]?.Visual_Examination);
      console.log('Liquid Penetrant in PDF:', pdfArray[1]?.Liquid_Penetrant_Examination);
      console.log('Macro Examination in PDF:', pdfArray[1]?.Macro_Examination);
      console.log('Minimum Leak Path in PDF:', pdfArray[1]?.Minimum_Leak_Path);
    }
    console.log('=== END PDF DATA ===');

    // Fetch images
    const newImageUrls = { ...imageUrls };
    const pdfFirstData = pdfArray[0];

    if (pdfFirstData?.wld_WPSType === "Tubesheet") {
      await fetchImagePreview(folderpqrtube, pdfFirstData.Pdf_images?.[0]?.tube_Hole_ligament?.[0], (url) => newImageUrls.previewUrl1 = url);
      await fetchImagePreview(folderpqrtube, pdfFirstData.Pdf_images?.[1]?.tube_Hole?.[0], (url) => newImageUrls.previewUrl2 = url);
      await fetchImagePreview(folderpqrtube, pdfFirstData.Pdf_images?.[2]?.tube_Weld_Joint?.[0], (url) => newImageUrls.previewUrl3 = url);
    } else {
      await fetchImagePreview(folderpqr, pdfFirstData.Pdf_images?.[0]?.pqr_image1?.[0], (url) => newImageUrls.previewUrlgroove1 = url);
      await fetchImagePreview(folderpqr, pdfFirstData.Pdf_images?.[1]?.pqr_image2?.[0], (url) => newImageUrls.previewUrlgroove2 = url);
    }
    
    await fetchImagePreview(folderwld, pdfFirstData.PQR_SignaturePrepared, (url) => newImageUrls.previewuser = url);
    await fetchImagePreview(folderwld, pdfFirstData.PQR_SignatureApproved, (url) => newImageUrls.previewapproved = url);
    
    // Single state update with both PDF and images
    setPdfData({ pdf: pdfArray, imageUrls: newImageUrls });
  };

  useEffect(() => {
    fetchPdfWithImages(props?.rowdata?.PK, props?.rowdata?.PQR_RecordNo);
  }, []); 
  const downloadPdf = () => {
    setTimeout(() => {
      let doc = new jsPDF("p", "pt", [595.28, 1020]);
      doc = Jspdf_font(doc)
      let pdfjs = document.querySelector("#MainDiv");
      doc.html(pdfjs, {
        callback: function (doc) {
          let Filename = `PQR Report ${pdfData.pdf[0].wld_WPSType}`;
          doc.save(Filename);
          props.onHide();
          props.setReload(!props.reload);
          setLoading(false);
          doc.setFontSize(10);
        },
        margin: [-25, 10, 10, 10],
      });
    }, 9000);
  };

  useEffect(() => {
    if (pdfData.pdf.length > 0) {
      downloadPdf();
    }
  }, [pdfData]);

  return (
    <>
      <Modal
        {...props}
        size="sm"
        centered
        transparent={true}
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Body
          style={{
            maxHeight: "calc(10vh - 10px)",
          }}
        >
          <p>
            {loading && (
              <BarLoader
                color="blue"
                height={8}
                width={196}
                className="shift"
              />
            )}
          </p>
        </Modal.Body>
      </Modal>

      {pdfData.pdf.length > 0 && (
        <div id="MainDiv">
          <br></br>
          {pdfData.pdf[0]?.wld_WPSType === "Tubesheet" ? (
            <>
              <PQRTubeToTubesheet_pdf_page1
                pdf={pdfData.pdf}
                PreviewUrl={PreviewUrl}
                previewUrl1={pdfData.imageUrls.previewUrl1}
                previewUrl2={pdfData.imageUrls.previewUrl2}
                previewUrl3={pdfData.imageUrls.previewUrl3}
                previewuser={pdfData.imageUrls.previewuser}
                previewapproved={pdfData.imageUrls.previewapproved}
              />
              <PQRTubeToTubesheet_pdf_page2
                pdf={pdfData.pdf}
                PreviewUrl={PreviewUrl}
                previewuser={pdfData.imageUrls.previewuser}
                previewapproved={pdfData.imageUrls.previewapproved}
              />
              <div style={{ backgroundColor: "none", height: "410px", position: "relative", top: "70px" }}></div>

              <PQRTubeToTubesheet_pdf_page3
                pdf={pdfData.pdf}
                PreviewUrl={PreviewUrl}
                previewuser={pdfData.imageUrls.previewuser}
                previewapproved={pdfData.imageUrls.previewapproved}
              />
            </>
          ) : (
            <>
              <Groove_pdf_page1PQR
                pdf={pdfData.pdf}
                previewuser={pdfData.imageUrls.previewuser}
                previewapproved={pdfData.imageUrls.previewapproved}
                previewUrl1={pdfData.imageUrls.previewUrlgroove1}
                previewUrl2={pdfData.imageUrls.previewUrlgroove2}
              />

              {
              //Separator
              pdfData.pdf[0]?.wld_WPSType === "Overlay" ? (
                <div style={{ backgroundColor: "none", height: "125px", position: "relative", top: "50px" }}></div>) 
                : (
                <div style={{ backgroundColor: "none", height: "65px", position: "relative", top: "10px" }}></div>
                
                )
                 //Separator
                }
             
              {
              //4th Process new page
              pdfData.pdf[4] && <Groove_pdf_page2
                pdf={pdfData.pdf}
                previewuser={pdfData.imageUrls.previewuser}
                previewapproved={pdfData.imageUrls.previewapproved}
              />
              }

              {
              //Separator
              pdfData.pdf[4] && <> {pdfData.pdf[0]?.wld_WPSType === "Overlay" ? (
                <div style={{ height: "380px", position: "relative", top: "115px" }}></div>) 
                
                : <div style={{ height: "300px", position: "relative", top: "30px" }}></div>}</>
                
                 //Separator
                }
                
              <Groove_pdf_page2PQR
                pdf={pdfData.pdf}
                previewuser={pdfData.imageUrls.previewuser}
                previewapproved={pdfData.imageUrls.previewapproved}
                showTensileTest={pdfData.pdf[0]?.showTensileTest || false}
                showGuidedBendTest={pdfData.pdf[0]?.showGuidedBendTest || false}
                showOtherTest={pdfData.pdf[0]?.showOtherTest || false}
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default Pdf_DownloadPQR;
